import { useEffect } from "react";

/**
 * Hook which disables the browser back button
 *
 * Not guaranteed to work in all cases, but should work most of the time
 */
export const useBackProtection = (onBackAttempted: () => void) => {
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const preventPopState = () => {
      window.history.pushState(null, "", window.location.href);
      onBackAttempted();
    };

    window.addEventListener("popstate", preventPopState);
    return () => window.removeEventListener("popstate", preventPopState);
  }, [onBackAttempted]);
};
